import { MerchType } from '@api';
import { DotNotationPaths } from '@common';
import { VenueDetailsOverviewEndKey } from 'src/i18next';

export type VenueMerchTableRowType = {
  label: VenueDetailsOverviewEndKey<'VENUE_MERCH.ROWS'>;
  accessor: DotNotationPaths<MerchType>;
};

export const venueMerchRows: VenueMerchTableRowType[] = [
  {
    label: 'RATE',
    accessor: 'rate',
  },
  {
    label: 'CONTACT',
    accessor: 'contact',
  },
  {
    label: 'NOTES',
    accessor: 'notes',
  },
];

